<template>
  <div>
    <div class="py-2 d-flex flex-wrap mx-0" v-if="editing">
      <accessory-select
        class="accessory-select"
        @change="onParameterChanged"
        :dataKeys="['accessory_id']"
        classes="grey"
      />
      <number-input
        :value="1"
        :minValue="1"
        @change="onParameterChanged"
        :dataKeys="['quantity']"
        class="ml-3"
      />
      <button
        class="btn btn-link font-weight-semibold text-primary mb-0 my-md-auto mt-auto p-0 ml-3 clickable"
        @click="onSaveClicked"
        :disabled="!valid"
      >
        Aggiungi
      </button>
    </div>
    <div class="py-2 row mx-0 clickable" v-else @click="editing = true">
      <i class="fas fa-plus text-primary my-auto px-0"></i>
      <p
        class="font-weight-semibold text-primary col-4 col-md-3 my-auto px-0 ml-3"
      >
        Aggiungi
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Mixins, Prop, Watch } from "vue-property-decorator";
import InlineEditor from "components/InlineEditor.vue";
import OrdersMixin from "mixins/http/OrdersMixin";
import AccessorySelect from "components/Accessory/Select.vue";
import { RegisterHttp } from "utils/Decorators";
import { RequestData } from "store/types";
import NumberInput from "components/NumberInput.vue";

@Component({ components: { InlineEditor, AccessorySelect, NumberInput } })
export default class CreateOrderAccessoryItem extends Mixins(OrdersMixin) {
  static readonly createTag = "create_order_accessory";

  @RegisterHttp(CreateOrderAccessoryItem.createTag) createRequestd: RequestData;

  @Prop({ required: true })
  orderId: string;

  private data: any = { quantity: 1 };
  private editing: boolean = false;

  get valid() {
    return this.data.quantity > 0 && this.data.accessory_id;
  }

  reset() {
    this.data.model = undefined;
    this.data.accessory_id = undefined;
  }

  onParameterChanged(value) {
    this.data = {
      order_id: this.orderId,
      ...this.data,
      ...value,
    };
  }

  onSaveClicked() {
    if (!this.valid) {
      return;
    }

    this.createOrderAccessory(
      this.data,
      CreateOrderAccessoryItem.createTag,
    ).then((resp) => {
      this.$emit("created", resp);
      this.reset();
      this.editing = false;
    });
  }
}
</script>

<style scoped>
.accessory-select {
  width: 250px;
}
</style>
